var Anhui = "Anhui";
var Beijing = "Peking";
var Chongqing = "Chongqing";
var Fujian = "Fujian";
var Gansu = "Gansu";
var Guangdong = "Guangdong";
var Guangxi = "Guangxi";
var Guizhou = "Guizhou";
var Hainan = "Hainan";
var Hebei = "Hebei";
var Heilongjiang = "Heilongjiang";
var Henan = "Henan";
var Hubei = "Hubei";
var Hunan = "Hunan";
var Jiangsu = "Jiangsu";
var Jiangxi = "Jiangxi";
var Jilin = "Jilin";
var Liaoning = "Liaoning";
var Ningxia = "Ningxia";
var Qinghai = "Qinghai";
var Shaanxi = "Shaanxi";
var Shandong = "Shandong";
var Shanghai = "Shanghai";
var Shanxi = "Shanxi";
var Sichuan = "Sichuan";
var Tianjin = "Tianjin";
var Tibet = "Tibet";
var Xinjiang = "Xinjiang";
var Yunnan = "Yunnan";
var Zhejiang = "Zhejiang";
var CNStates = {
	Anhui: Anhui,
	Beijing: Beijing,
	Chongqing: Chongqing,
	Fujian: Fujian,
	Gansu: Gansu,
	Guangdong: Guangdong,
	Guangxi: Guangxi,
	Guizhou: Guizhou,
	Hainan: Hainan,
	Hebei: Hebei,
	Heilongjiang: Heilongjiang,
	Henan: Henan,
	Hubei: Hubei,
	Hunan: Hunan,
	"Inner Mongolia": "Innere Mongolei",
	Jiangsu: Jiangsu,
	Jiangxi: Jiangxi,
	Jilin: Jilin,
	Liaoning: Liaoning,
	Ningxia: Ningxia,
	Qinghai: Qinghai,
	Shaanxi: Shaanxi,
	Shandong: Shandong,
	Shanghai: Shanghai,
	Shanxi: Shanxi,
	Sichuan: Sichuan,
	Tianjin: Tianjin,
	Tibet: Tibet,
	Xinjiang: Xinjiang,
	Yunnan: Yunnan,
	Zhejiang: Zhejiang
};

export { Anhui, Beijing, Chongqing, Fujian, Gansu, Guangdong, Guangxi, Guizhou, Hainan, Hebei, Heilongjiang, Henan, Hubei, Hunan, Jiangsu, Jiangxi, Jilin, Liaoning, Ningxia, Qinghai, Shaanxi, Shandong, Shanghai, Shanxi, Sichuan, Tianjin, Tibet, Xinjiang, Yunnan, Zhejiang, CNStates as default };
